'use client';

import clsx from 'clsx';
import { useDropdownContext } from '../../../DropdownProvider';
import { useHamburgerToggleClick } from './hooks';

const hamburgerToggleClassnames = [
  'absolute',
  'w-[62%]',
  'h-[1.5px]',
  'bg-black',
  'transition-all',
  'duration-300',
  'ease-in-out',
];

export function HamburgerToggle() {
  const { state } = useDropdownContext();
  const handleHamburgerToggleClick = useHamburgerToggleClick();

  return (
    <div id="satellite-hamburger" className={clsx('block', 'p-4', 'lg:hidden')}>
      <button
        tabIndex={2}
        aria-expanded={state.isShowingMobileNav}
        aria-controls="mobile-nav-menu"
        aria-label="Toggle mobile navigation"
        id="satellite-hamburger-label"
        className={clsx(
          'cursor-pointer',
          'flex',
          'items-center',
          'justify-center',
          'h-6',
          'w-6',
          'relative',
        )}
        onClick={handleHamburgerToggleClick}
      >
        <span
          className={clsx(hamburgerToggleClassnames, {
            'top-[calc(50%-0.375rem)]': !state.isShowingMobileNav,
            'top-1/2': state.isShowingMobileNav,
            'rotate-45': state.isShowingMobileNav,
          })}
        />
        <span
          className={clsx(hamburgerToggleClassnames, 'top-1/2', {
            'bg-transparent': state.isShowingMobileNav,
          })}
        />
        <span
          className={clsx(hamburgerToggleClassnames, {
            'top-[calc(50%+0.375rem)]': !state.isShowingMobileNav,
            'top-1/2': state.isShowingMobileNav,
            '-rotate-45': state.isShowingMobileNav,
          })}
        />
      </button>
    </div>
  );
}
